var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotel-list-view"},[_c('h1',[_vm._v(" Список отелей ")]),_c('hotel-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }